import { apiClient, Auth } from '@/shared/api'

type HostPayRoom = {
  rid: number
  roomName: string
}

export const getHostPayRooms = async () => {
  const { data } = await apiClient.get<HostPayRoom[]>({
    endpoint: `/settlements/rooms`,
    auth: Auth.REQUIRED,
  })

  return data
}
